// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"5ac696da","224":"33ee305a","226":"c3dc649f","361":"1db27247"}[chunkId] + ".chunk.js";
};